import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import GiftCardLayer from "../../components/GiftCard/GiftCardLayer";

const GiftCardPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Gift Card" />

        <GiftCardLayer />
      </MasterLayout>
    </>
  );
};

export default GiftCardPage;
